<template>
  <div v-if="pseudoVariants" class="pseudo-variants option-set margin-top">
    <p class="pseudo-variants__title option-set__top">
      <span class="option-set__label">Color</span>
      <span class="option-set__value" ref="title">{{ variantColor }}</span>
    </p>
    <div class="pseudo-variants__items">
      <div
        v-for="variant in sortedPseudoVariants"
        :key="`variant_${variant.id}`"
        :class="['pseudo-variants__item', { 'pseudo-variants__item--disabled': !variant.available, 'active': variant.handle === product.handle, }]"
      >
        <a
          :href="variantUrl(variant)"
          :style="`background-image: url('${variant.thumbnailImage}')`"
          @mouseenter="showVariantColor(variant)"
          @mouseleave="showCurrentColor()"
        >{{ variant.title }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductColorVariants',
  props: {
    pseudoVariants: Array,
    product: Object,
  },
  data() {
    return {
      variantColor: this.product.title.split('-').pop().trim(),
    };
  },
  computed: {
    genderedVariant() {
      const query = window.location.search;
      const params = new URLSearchParams(query);
      const womens = params.get('womens');
      const mens = params.get('mens');

      if (womens)
        return 'womens'
      else if (mens)
        return 'mens'
      else
        return false;
    },
    sortedPseudoVariants() {
      return this.pseudoVariants.sort((variantA, variantB) => {
        if (variantA.handle === this.product.handle) return -1;
        if (!variantA.available && variantB.available) return 1;
        if (variantA.available && !variantB.available) return -1;

        return 0;
      })
    },
  },
  methods: {
    variantUrl(variant) {
      const url = new URL(`${document.location.origin}${variant.url}`);
      const isDifferentHandle = variant.handle !== this.product.handle;

      if (isDifferentHandle) {
        if (this.genderedVariant) url.searchParams.set(this.genderedVariant, true);
        return url.href;
      }
      
      return'javascript:void(0)'
    },
    showVariantColor(variant) {
      return (this.variantColor = variant.title.split('-').pop().trim());
    },
    showCurrentColor() {
      return (this.variantColor = this.product.title.split('-').pop().trim());
    },
  },
};
</script>

<style scoped lang="scss">
.pseudo-variants {
  &__title {
    @include body-sm;
    display: block;
    margin-bottom: 5px;
  }
  &__items {
    display: flex;
    flex-wrap: wrap;
  }
  &__item {
    position: relative;
    height: 55px;
    width: 55px;
    margin-right: 20px;
    margin-bottom: 20px;

    &--disabled {
      opacity: 0.3;
      pointer-events: none;
    }

    @include mobile-only {
      width: 43px;
      height: 43px;
    }

    &:last-child {
      margin-right: 0;
    }
    &.active {
      a {
        border: 1px solid $color-black;
        border-radius: 1px;
      }
    }
    a {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
}
</style>
